import {
  Home,
  MonitorSmartphone,
  CalendarClock,
  Phone,
  Search,
  GraduationCap,
  ShieldCheck,
  HeartHandshake,
  MessagesSquare,
  Wallet,
} from "lucide-react";

// HUOM: Yhteystiedot ovat paikkamerkkejä – päivitä omilla tiedoillasi.
export const contactInfo = {
  phone: "046 802 8874",
  phoneHref: "tel:+358468028874",
  email: "vili@digivili.fi",
  area: "Lappeenranta ja Etelä-Karjala (kotikäynnit) sekä etätuki koko Suomeen",
  businessName: "Matilda Media",
  yTunnus: "3469822-4",
};

export const services = [
  {
    icon: Home,
    title: "Digituki kotiisi",
    text: "Tulen luoksesi ja autan rauhassa juuri sinun laitteidesi kanssa – tietokone, puhelin, tabletti tai vaikka television sovellukset.",
  },
  {
    icon: MonitorSmartphone,
    title: "Etätuki puhelimitse",
    text: "Nopeaan pulmaan saat apua etänä. Ohjaan selkeästi puhelimessa tai otan etäyhteyden koneeseesi luvallasi.",
  },
  {
    icon: GraduationCap,
    title: "Selkokielinen opastus",
    text: "Opetellaan yhdessä sinun tahtiisi. Käymme asiat läpi konkreettisten arjen esimerkkien avulla, ilman vaikeita termejä.",
  },
  {
    icon: ShieldCheck,
    title: "Turvallisuus & huijausten tunnistus",
    text: "Opit tunnistamaan huijausviestit ja käyttämään verkkopankkia sekä sovelluksia turvallisesti ja luottavaisin mielin.",
  },
  {
    icon: Wallet,
    title: "Kulujen tarkistus",
    text: "Käymme läpi liittymät ja tilaukset – perutaan turhat maksut ja varmistetaan, ettet maksa liikaa.",
  },
  {
    icon: CalendarClock,
    title: "Kuukausituki",
    text: "Halutessasi saat oman digituen jatkuvasti käyttöösi kuukausipaketilla – apu on aina lähellä, kun sitä tarvitset.",
  },
];

export const steps = [
  {
    icon: Phone,
    title: "1. Ota yhteyttä",
    text: "Soita tai jätä yhteydenottopyyntö. Kerro omin sanoin, missä kaipaat apua – mikään pulma ei ole liian pieni.",
  },
  {
    icon: Search,
    title: "2. Kartoitetaan tilanne",
    text: "Selvitetään yhdessä, mitä tarvitset. Sovitaan sinulle sopiva aika kotikäynnille tai etätuelle.",
  },
  {
    icon: HeartHandshake,
    title: "3. Opitaan yhdessä",
    text: "Ratkaisemme pulman rauhassa ja opit samalla itse. Lähdet rohkeammin eteenpäin oman laitteesi kanssa.",
  },
];

export const pricing = [
  {
    name: "Etätuki",
    price: "39 €",
    unit: "/ 30 min",
    featured: false,
    note: "Laskutus 30 minuutin tarkkuudella – maksat vain käyttämästäsi ajasta.",
    items: ["Apua puhelimitse", "Etäyhteys koneeseesi luvallasi", "Sopii nopeisiin pulmiin", "Ei pitkiä sopimuksia"],
  },
  {
    name: "Kotikäynti",
    price: "59 €",
    unit: "/ tunti",
    featured: true,
    note: "Tulen luoksesi sovittuna aikana. Kotitalousvähennys huomioiden hinta voi olla edullisempi.",
    items: ["Henkilökohtainen apu kotonasi", "Laitteiden asennus ja käyttöönotto", "Rauhallinen opastus", "Oikeus kotitalousvähennykseen"],
  },
  {
    name: "Kuukausituki",
    price: "alk. 99 €",
    unit: "/ kk",
    featured: false,
    note: "Oma digituki jatkuvasti käytössä. Sisältää säännölliset tapaamiset ja etätuen.",
    items: ["Säännöllinen apu", "Jatkuva etätuki", "Ennakoiva neuvonta", "Mielenrauhaa läheisillekin"],
  },
];

export const faqs = [
  {
    q: "Kenelle Digivili on tarkoitettu?",
    a: "Digivili on kaikille, jotka kaipaavat rauhallista ja selkeää apua digilaitteiden kanssa – erityisesti senioreille ja henkilöille, joille tekniikka tuntuu vieraalta. Autan myös läheisiä, jotka haluavat varmistaa, että heidän omaisensa pärjää teknologian kanssa.",
  },
  {
    q: "Mitä laitteita autat käyttämään?",
    a: "Autan kaikkien tavallisten arjen laitteiden kanssa: älypuhelimet, tietokoneet, tabletit, tulostimet, älytelevisiot ja niiden sovellukset. Neuvon myös verkkopankin, sähköpostin, videopuheluiden ja sosiaalisen median käytössä.",
  },
  {
    q: "Miten laskutus toimii?",
    a: "Et sitoudu pitkiin sopimuksiin. Etätuessa laskutan 30 minuutin tarkkuudella, joten maksat vain käyttämästäsi ajasta. Kotikäynneissä laskutus on tuntiperusteinen. Saat aina hinnan tietoosi etukäteen.",
  },
  {
    q: "Voinko saada kotitalousvähennyksen?",
    a: "Kotikäynteinä tehtävä digituki oikeuttaa usein kotitalousvähennykseen, mikä pienentää lopullista hintaa. Kerron mielelläni lisää, kun olemme yhteydessä.",
  },
  {
    q: "Entä jos en osaa selittää ongelmaani?",
    a: "Ei hätää – sinun ei tarvitse osata mitään etukäteen. Kerro vain omin sanoin, mikä mietityttää, niin selvitetään asia yhdessä. Mikään kysymys ei ole tyhmä.",
  },
  {
    q: "Millä alueella toimit?",
    a: "Teen kotikäyntejä Lappeenrannassa ja Etelä-Karjalan alueella. Etätukea tarjoan puhelimitse koko Suomeen, joten apua saa asuinpaikasta riippumatta.",
  },
];

export const testimonials = [
  {
    name: "Aino, 74",
    role: "Asiakas, Helsinki",
    text: "Olin aivan ymmälläni uuden puhelimeni kanssa. Digivili kävi kotona ja opetti rauhassa. Nyt soitan videopuheluita lapsenlapsilleni joka viikko!",
  },
  {
    name: "Markku, 68",
    role: "Asiakas, Imatra",
    text: "Sain vihdoin apua verkkopankin kanssa selkeästi selitettynä. Ei kiirettä, ei vaikeita sanoja. Suosittelen lämpimästi kaikille ikätovereille.",
  },
  {
    name: "Sanna",
    role: "Tyttären terveiset",
    text: "Äitini sai oman digituen, ja se on tuonut valtavasti mielenrauhaa koko perheelle. Tiedämme, että apu on aina lähellä.",
  },
];

export const whyPoints = [
  {
    icon: HeartHandshake,
    title: "Yli 10 vuotta kokemusta ihmisten auttamisesta",
    text: "Taustani vammaistyössä on opettanut kärsivällisyyttä ja kykyä selittää asiat niin, että jokainen ymmärtää.",
  },
  {
    icon: MessagesSquare,
    title: "Selkokieltä – ei vaikeita termejä",
    text: "Puhun ihmisten kieltä. Liitän asiat tuttuihin arjen tilanteisiin, jolloin vaikeatkin asiat aukeavat helposti.",
  },
  {
    icon: ShieldCheck,
    title: "Sama luotettava ihminen joka kerta",
    text: "Et joudu jonottamaan asiakaspalveluun. Saat oman, tutun digituen, joka tuntee sinut ja laitteesi.",
  },
];
